import { ICON_FIELD } from '../elements/assets'

export const BENEFITS_SECTION = `
...on benefitsSection_Entry {
  id
  typeHandle

  heading: headingAdvanced { html }

  cards: benefitsSectionCards {
    ... on benefitsSectionCard_Entry {
      id
      title

      ${ ICON_FIELD }

      textBlock
    }
  }
}
`
